import { render, staticRenderFns } from "./BaseFormInfoField.vue?vue&type=template&id=81e07f16&scoped=true"
import script from "./BaseFormInfoField.vue?vue&type=script&lang=ts"
export * from "./BaseFormInfoField.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "81e07f16",
  null
  
)

export default component.exports